/*
/assets/wpx-re-order-thumbnails.js

Wait for DOM load.
Grab data-variant-id from parent container (.product__thumbs--scroller).
Move matching .product__thumb-item[data-variant-id="..."] to top of the container.

loaded inside /layout/theme.liquid with <script src="{{ 'wpx-re-order-thumbnails.js' | asset_url }}" defer></script>

*/

function reorderVariantThumbs() {
  const thumbsScroller = document.querySelector(".product__thumbs--scroller");
  if (!thumbsScroller) return;

  const activeVariantId = thumbsScroller.dataset.variantId;
  if (!activeVariantId) return;

  const thumbItems = Array.from(thumbsScroller.querySelectorAll(".product__thumb-item"));
  const matchedItem = thumbItems.find(item => item.dataset.variantId === activeVariantId);

  if (matchedItem) {
    thumbsScroller.insertBefore(matchedItem, thumbsScroller.firstChild);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  reorderVariantThumbs();

  // Hook into Shopify's variant change event
  document.querySelectorAll("[data-product-single-option-selector]").forEach(selector => {
    selector.addEventListener("change", () => {
      // delay for Shopify's internal variant update
      setTimeout(reorderVariantThumbs, 50);
    });
  });
});